import clsx from 'clsx';
import Link from 'next/link';

export type StepperProps = {
	list: StepperItemParams[];
};

export type StepperItemParams = {
	name: string;
	href?: string;
	active?: boolean;
	passed?: boolean;
};

export function Stepper({ list }: StepperProps) {
	return (
		<div className="flex flex-row gap-2">
			{list.map((item, key) => {
				const cn = clsx(
					'block h-[6px] w-full rounded-full transition-colors',
					'bg-gray-5',
					{
						'!bg-gray-4': item?.active,
						'!bg-green': item?.passed,
					},
				);
				if (!item?.href) {
					return <span key={key} className={cn} aria-label={item.name} />;
				}
				return (
					<Link
						key={key}
						href={item.href}
						className={cn}
						aria-label={item.name}
					/>
				);
			})}
		</div>
	);
}
